import { useTranslation } from 'react-i18next'
import {
  buildLevelMapping,
  getPreferredResponseCode
} from '@BUP/utils/diagnosticLevels'
import ProgressComponent from './progressComponent'

const PercentageProgressCard = ({ studentData, availableLevels, selectedLevel }) => {
  const { i18n } = useTranslation()
  const { surveyTotalData, totalAnswers } = studentData

  if (!surveyTotalData || !totalAnswers) return null

  const totalStudent = surveyTotalData.settings.enivel
  const studentResponses = totalAnswers.enivel

  const mappedLevels = availableLevels || buildLevelMapping(surveyTotalData.settings, i18n.language)
  const visibleLevels = selectedLevel
    ? mappedLevels.filter(level => level.code === selectedLevel)
    : mappedLevels

  const startwithEnivel = Object.prototype.hasOwnProperty.call(studentData.totalAnswers, 'enivel')

  const percentagesByNivel = visibleLevels.map((level) => {
    if (!startwithEnivel) {
      return {
        value: 0,
        code: level.code,
        nivel: level.displayName,
        label: level.label,
        totalResponses: 0
      }
    }

    const responseCodeTotal = getPreferredResponseCode({
      canonicalCode: level.code,
      sourceCodes: level.sourceCodes,
      sourceMap: studentResponses
    })
    const responseCodeMin = getPreferredResponseCode({
      canonicalCode: level.code,
      sourceCodes: level.sourceCodes,
      sourceMap: totalStudent
    })

    const responses = studentResponses?.[responseCodeTotal] || 0
    const min = totalStudent?.[responseCodeMin]?.min || 0
    const value = min ? Math.round((responses / min) * 100) : 0

    return {
      value,
      nivel: level.displayName,
      label: level.label,
      code: level.code,
      responseCode: responseCodeTotal,
      totalResponses: responses
    }
  })

  const minTotal = surveyTotalData?.settings?.min
  const calculateTotalprogress = minTotal
    ? Math.round((totalAnswers.total / minTotal) * 100)
    : 0
  return (
    <ProgressComponent
      percentagesByNivel={percentagesByNivel}
      calculateTotalprogress={calculateTotalprogress}
    />
  )
}

export default PercentageProgressCard
